module.exports = __WEBPACK_EXTERNAL_MODULE_24__;


//////////////////
// WEBPACK FOOTER
// external "angular-filter"
// module id = 24
// module chunks = 0